// analytics.js
import { createSlice } from '@reduxjs/toolkit';
import {
    getAverageResults,
    getLeanersAboveAcsfLevel3,
    getQuizUsed,
    getTotalCompletedQuizzesByMonth,
    getTotalCreatedCourses,
    getTotalLLNReportsGenerated,
    getTotalLLNReportsGeneratedByMonth,
    getTotalQuizzesCompleted,
    getTotalUnitsAnalysed,
    getTotalvgQuizCompletionTime
} from 'api/analytic';

const initialState = {
    analytics: [
        { key: 'courses-created', isFetching: false, data: null, error: null, imgURI: null },
        { key: 'units-analysed', isFetching: false, data: null, error: null, imgURI: null },
        { key: 'quizzes-completed', isFetching: false, data: null, error: null, imgURI: null },
        { key: 'average-quiz-time', isFetching: false, data: null, error: null, imgURI: null },
        { key: 'lln-reports-generated', isFetching: false, data: null, error: null, imgURI: null },
        { key: 'learners-at-or-above-acsf3-lvl-3', isFetching: false, data: null, error: null, imgURI: null },
        { key: 'completed-quizzes-by-month', isFetching: false, data: null, error: null, imgURI: null },
        { key: 'quiz-used', isFetching: false, data: null, error: null, imgURI: null },
        { key: 'average-results', isFetching: false, data: null, error: null, imgURI: null },
        { key: 'total-lln-reports-generated-by-month', isFetching: false, data: null, error: null, imgURI: null }
    ],
    params: {
        dateFrom: new Date(new Date().setDate(new Date().getDate() - 30)), // 30 days before
        dateTo: new Date()
    }
};

const slice = createSlice({
    name: 'analytic',
    initialState,
    reducers: {
        setParams(state, action) {
            state.params = action.payload;
        },
        setAnalyticFetching(state, { payload: { key, isFetching } }) {
            const item = state.analytics.find((a) => a.key === key);
            if (item) item.isFetching = isFetching;
        },
        setAnalyticData(state, { payload: { key, data } }) {
            const item = state.analytics.find((a) => a.key === key);
            if (item) {
                item.data = data;
                item.error = null;
            }
        },
        setAnalyticError(state, { payload: { key, error } }) {
            const item = state.analytics.find((a) => a.key === key);
            if (item) {
                item.error = error;
            }
        },
        setAnalyticImgURI(state, { payload: { key, imgURI } }) {
            const item = state.analytics.find((a) => a.key === key);
            if (item) {
                item.imgURI = imgURI;
            }
        }
    }
});

export const { setParams, setAnalyticFetching, setAnalyticData, setAnalyticError, setAnalyticImgURI } = slice.actions;

export default slice.reducer;

export function fetchAnalytic(params, type) {
    return async (dispatch) => {
        dispatch(setAnalyticFetching({ key: type, isFetching: true }));
        try {
            let response;
            if (type === 'courses-created') {
                response = await getTotalCreatedCourses(params);
            } else if (type === 'units-analysed') {
                response = await getTotalUnitsAnalysed(params);
            } else if (type === 'quizzes-completed') {
                response = await getTotalQuizzesCompleted(params);
            } else if (type === 'average-quiz-time') {
                response = await getTotalvgQuizCompletionTime(params);
            } else if (type === 'lln-reports-generated') {
                response = await getTotalLLNReportsGenerated(params);
            } else if (type === 'learners-at-or-above-acsf3-lvl-3') {
                response = await getLeanersAboveAcsfLevel3(params);
            } else if (type === 'completed-quizzes-by-month') {
                response = await getTotalCompletedQuizzesByMonth(params);
            } else if (type === 'quiz-used') {
                response = await getQuizUsed(params);
            } else if (type === 'average-results') {
                response = await getAverageResults(params);
            } else if (type === 'total-lln-reports-generated-by-month') {
                response = await getTotalLLNReportsGeneratedByMonth(params);
            } else {
                throw new Error(`Unknown analytics key: ${type}`);
            }
            dispatch(setAnalyticData({ key: type, data: response.data ?? null }));
        } catch (err) {
            dispatch(setAnalyticError({ key: type, error: String(err) }));
        } finally {
            dispatch(setAnalyticFetching({ key: type, isFetching: false }));
        }
    };
}
